module.exports = "<mat-calendar (selectedChange)=\"addEvent($event)\" [dateClass]=\"dateClass\" #picker></mat-calendar>"